import { setSelectedView } from '@/store/slices/assetsPreviewSlice';
import { dispatch } from '@/store/store';
import { BaseIconButton } from '@/components';
import { Icon } from '@/components/shared/display/Icon';
import { cn } from '@/lib/utils';
import { Grid2SolidFilledIcon, GripLinesIcon } from '@/assets/Icons';
import React from 'react';
{
  /* @TODO:replace with toggle btns (typeof tabs)\? */
}

interface AssetPreviewViewsSelectorsProps {
  selectedView: 'grid' | 'list' | 'table';
}

export const AssetPreviewViewsSelectors = ({ selectedView }: AssetPreviewViewsSelectorsProps) => {
  return (
    <div className="xl:flex rounded-xl hidden " data-testid="test-123">
      <BaseIconButton
        label={'Grid'}
        showLabel={true}
        classNames={{
          button: cn(
            ' border-2  first-of-type:rounded-r-none first-of-type:border-r-none  w-full px-5 py-3 h-100',
            selectedView === 'grid' ? 'bg-accent text-accent-foreground border-accent' : 'hover:bg-neutral-25'
          ),
        }}
        variant={'tab'}
        icon={Grid2SolidFilledIcon}
        onClick={() => dispatch(setSelectedView('grid'))}
      />
      <BaseIconButton
        classNames={{
          button: cn(
            'border-2 last-of-type:rounded-l-none w-full px-5 py-5  last-of-type:border-l-none py-3 h-100',
            selectedView === 'table' ? 'bg-accent text-accent-foreground border-accent' : 'hover:bg-neutral-25'
          ),
        }}
        label={'List'}
        showLabel={true}
        variant={'tab'}
        icon={GripLinesIcon}
        onClick={() => dispatch(setSelectedView('table'))}
      />
    </div>
  );
};
